import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  () => ({
    root: {
      minWidth: 100,
    },
  }),
  { name: 'InviteUsersButton' }
);
